import publicApiCall from "../utils/axiosCall";

export const contactUsFormCall = (data) => {
  return publicApiCall.postPublic("app/contact-us", data);
};

export const submitFeedbackCall = (data) => {
  return publicApiCall.postPublic("app/feedback", data);
};

export const subscribeNewsletter = (data) => {
  return publicApiCall.postPublic("app/subscribe", data);
};
